import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { useDroneDetailContext } from '../Contexts/DroneDetailContext';
import { MenuItem, MillAreaIcon, ProfileGroundIcon, SelectIcon } from './MapActionMenu';

const MillMapMenu = ({ GIS, projectId, epsg }) => {
  const [prevSelection, setPrevSelection] = useState(null);
  const { featuresData, setFeaturesData, selectedFeature, setSelectedFeature, setUnsavedChanges, selectedTool, setSelectedTool, deletedFeature } = useDroneDetailContext();


  const addFeature = ({ featureId, geometry }) => {
    const feature = {
      properties: {
        area_m2: 0,
        area_type: 0,
        coefficient_def: {},
        coeficient: 0,
        date: "2020-11-20",
        description: "",
        height_ground: 0,
        id: featureId,
        id_project: projectId,
        isBox: false,
        log_length: 0,
        name: "",
        profile_type: 2,
        type: null,
        volume_coef_m3: 0,
        volume_m3: 0,
        epsg: epsg
      },
      type: "Feature",
      geometry: JSON.parse(geometry),
    }
    setFeaturesData( prev => [
      ...prev, feature
    ]);
    setSelectedFeature(feature)
  }

  const handleAddPolygon = () => {
    setSelectedTool("polygon")
    let latestId =0
    if(featuresData.length!==0){
      latestId= Math.max(...featuresData.map(f => f.properties.id));
    }
    GIS.Edit.drawFeatures('polygon', 'Polygon', false, (id) => {
      latestId++;

      GIS.Layer.setFeatureAttributeByID("polygon","id", latestId, id);
      GIS.Layer.setFeatureStyleByID('polygon', 'areaPile', latestId)
      GIS.Layer.setFeatureAttributeByID('polygon','label', `${latestId}`, latestId)
      GIS.Layer.getFeatureByID('polygon', latestId, { attribute: 'id', epsg: `EPSG:${epsg}`, format: 'geojson' }, geometry => {
      setUnsavedChanges(true);
        addFeature({
          featureId: latestId,
          geometry
        });
    });
    }, { incrementId: true, style: 'editing' })
  }

  const handleAddLine = () => {
    setSelectedTool("line")
    let latestId =0
    if(featuresData.length!==0){
      latestId= Math.max(...featuresData.map(f => f.properties.id));
    }
    GIS.Edit.drawFeatures('profile', 'LineString', false, (id) => {
      latestId++;
      GIS.Layer.setFeatureAttributeByID("profile","id", latestId, id);
      GIS.Layer.setFeatureStyleByID('profile', 'profileGround', latestId);
      GIS.Layer.setFeatureAttributeByID('profile','label', `${latestId}`, latestId);
      GIS.Layer.getFeatureByID('profile', latestId, { attribute: 'id', epsg: `EPSG:${epsg}`, format: 'geojson' }, geometry => {
        setUnsavedChanges(true);

        addFeature({
          featureId: latestId,
          geometry,
        });
      });
    }, { incrementId: true, style: 'editing' })
  }

  useEffect(() => {

      if(prevSelection?.properties.id !== deletedFeature?.properties.id){
        console.log(prevSelection);
        console.log(deletedFeature);
        if(prevSelection?.geometry.type === "Polygon"){
          GIS.Layer.setFeatureStyleByID('polygon', 'areaPile', prevSelection.properties.id);
          GIS.Layer.setFeatureAttributeByID('polygon','label', `${prevSelection.properties.id} - ${prevSelection?.properties?.name}`, prevSelection.properties.id);
        }
        if(prevSelection?.geometry.type === "LineString" && prevSelection.properties.profile_type===0){
          GIS.Layer.setFeatureStyleByID('profile', 'profileGround', prevSelection.properties.id);
          GIS.Layer.setFeatureAttributeByID('profile','label', `${prevSelection.properties.id} - ${prevSelection?.properties?.name}`, prevSelection.properties.id);
        }
        if(prevSelection?.geometry.type === "LineString" && prevSelection.properties.profile_type===2){
          GIS.Layer.setFeatureStyleByID('profile', 'profileGround', prevSelection.properties.id);
          GIS.Layer.setFeatureAttributeByID('profile','label', `${prevSelection.properties.id} - ${prevSelection?.properties?.name}`, prevSelection.properties.id);
        }
        if(prevSelection?.geometry.type === "LineString" && prevSelection.properties.profile_type===3){
          GIS.Layer.setFeatureStyleByID('profile', 'profileAI', prevSelection.properties.id);
          GIS.Layer.setFeatureAttributeByID('profile','label', `${prevSelection.properties.id} - ${prevSelection?.properties?.name}`, prevSelection.properties.id);
        }
    }
    
    if(selectedFeature?.geometry.type === "Polygon"){
      GIS.Layer.setFeatureStyleByID('polygon', 'selected', selectedFeature?.properties.id);
    }
    if(selectedFeature?.geometry.type === "LineString"){
      GIS.Layer.setFeatureStyleByID('profile', 'selected', selectedFeature?.properties.id);;
    }
    setPrevSelection(selectedFeature);
  },[selectedFeature]);

  const handleSelect = () => {
    setSelectedTool('selection')
    GIS.Interaction.setCallback('Identify', {}, (X, Y) => {

      const polygons = GIS.Layer.getFeatureIDsAtCoordinate('polygon', [X, Y])
      if (!isEmpty(polygons)) {
        console.log(polygons[0]);

        return setSelectedFeature(featuresData.find(f=>f.properties.id === polygons[0]));
      }
      const profileIds = GIS.Layer.getFeatureIDsAtCoordinate('profile', [X, Y], { attribute: 'id', strategy: 'closest', tolerance: 1 });
      if (!isEmpty(profileIds)) {
        console.log(profileIds[0])
        return setSelectedFeature(featuresData.find(f=>f.properties.id === profileIds[0]));
      }
    });
  }

  useEffect(() => {
    window.addEventListener("keydown", (key) => {
        if(key.key === 'Escape' && ['polygon', 'line', 'selection'].includes(selectedTool)) {
          setSelectedTool(null);
        }
    });
  }, [selectedTool]);

  return (
    <>
    <ReactTooltip type='light'/>
      <MenuItem data-tip="Draw Area" active={selectedTool === 'polygon'} onClick={()=>{GIS.Edit.commit();handleAddPolygon()}}>
        <MillAreaIcon />
      </MenuItem>
      <MenuItem data-tip="Draw Profile" active={selectedTool === 'line'} onClick={()=>{GIS.Edit.commit();handleAddLine()}}>
        <ProfileGroundIcon />
      </MenuItem>
      <MenuItem data-tip="Select Feature" active={selectedTool === 'selection'} onClick={()=>{GIS.Edit.commit();handleSelect()}}>
        <SelectIcon />
      </MenuItem>
    </>
  );
}

export default MillMapMenu;